import React, { useEffect, useState } from 'react'
import './package-subscription.css'
import PackageService from '../../../api/super-admin/PackageService'
import { Packagee } from '../../models/Package';
import { toast } from 'react-toastify'
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import PackageSubscriptionAPI from '../../../api/PackageSubscriptionAPI';

function PackageSubscription() {

  const [activePackageList, setActivePackageList] = useState<Packagee[]>([] as Packagee[]);

  const [showPaymentPopup, setShowPaymentPopup] = useState<boolean>(false);
  const [authorizationUrl, setAuthorizationUrl] = useState('')
  const [reference, setReference] = useState('')

  const navigate = useNavigate()

  useEffect(() => {
    getActivePackageList()
  }, [])

  const getActivePackageList = () => {
    PackageService.getActivePackageList().then(
      (res: any) => {
        if (res?.data?.success) {
          setActivePackageList(res?.data?.data)
        } else {
          toast.error(res?.data?.message, { theme: 'dark' })
          setActivePackageList([])
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, { theme: 'dark' })
      }
    )
  }

  // const handlePackageSubscription = (packageId: number) => {
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: 'Do you want to Subscribe the plan?',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes!',
  //   }).then((result: any) => {
  //     if (result.isConfirmed) {
  //       PackageSubscriptionAPI.subscribeNewPackage(packageId).then(
  //         (res: any) => {
  //           if (res?.data?.success) {
  //             // toast.success(res?.data?.message, { theme: 'dark' })
  //             const { authorization_url, access_code, reference } = res?.data?.data;
  //             // Define popup dimensions and position
  //             const width = 800;
  //             const height = 650;
  //             const left = (window.innerWidth - width) / 2;
  //             const top = (window.innerHeight - height) / 2 + 25;

  //             // Open Paystack payment page in a popup window
  //             const paymentWindow = window.open(
  //               authorization_url,
  //               'Paystack Payment',
  //               `width=${width},height=${height},top=${top},left=${left}`
  //             );
  //             if (paymentWindow) {
  //               const interval = setInterval(() => {
  //                 if (paymentWindow.closed) {
  //                   clearInterval(interval);
  //                   PackageSubscriptionAPI.verifyPayment(reference).then(
  //                     (res: any) => {
  //                       if (res?.data?.success) {
  //                         toast.success(res?.data?.message, { theme: 'dark' })
  //                         navigate('/settings/payment-history')
  //                       } else {
  //                         toast.error(res?.data?.message, {theme: 'dark'})
  //                       }
  //                     },
  //                     (err: any) => {
  //                       toast.error(err?.response?.data?.message, {theme: 'dark'})
  //                     }
  //                   )
  //                 }
  //               }, 100);
  //             } else {
  //               toast.error('Failed to open payment window.', {theme: 'dark'});
  //             }
  //           } else {
  //             toast.error(res?.data?.message, {theme: 'dark'})
  //           }
  //         },
  //         (err: any) => {
  //           toast.error(err?.response?.data?.message, {theme: 'dark'})
  //         }
  //       )
  //     }
  //   })
  // }

  const handlePackageSubscription = (packageId: number) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to Subscribe the plan?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!',
    }).then((result: any) => {
      if (result.isConfirmed) {
        PackageSubscriptionAPI.subscribeNewPackage(packageId).then(
          (res: any) => {
            if (res?.data?.success) {
              const { authorization_url, access_code, reference } = res?.data?.data
              setAuthorizationUrl(authorization_url)
              setShowPaymentPopup(true)
              setReference(reference)
            } else {
              toast.error(res?.data?.message, { theme: 'dark' })
            }
          },
          (err: any) => {
            toast.error(err?.response?.data?.message, { theme: 'dark' })
          }
        )
      }
    })
  }
  
  return (
    <>
      <div className='text-lg-end'>
      <Link
        to={'/settings/payment-history'}
      >
        <button className='history-btn px-4 py-2'>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" fill="currentColor" className="bi bi-clock-history" viewBox="0 0 16 16">
            <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z"/>
            <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z"/>
            <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5"/>
          </svg> Payment History
          </button>
      </Link>
      </div>
      <div className="container">
        <h1 className="header">Choose the right plan for your business</h1>
        <div className="package-list">
          {activePackageList.map((packagee, index) => (
            <div key={index} className="package">
              <div className="package-title">{packagee.title}</div>
              <div className="package-price">{packagee.price} NGN</div>
              <div className="package-discount">
                <span className="discount-percentage">{packagee.discount_percentage}% off</span>
                <span className="discount-amount"> Save {packagee.discount_amount}</span>
              </div>
              <div className="other-text">Up to {packagee.user_limit} Users</div>
              <div className="other-text">{packagee.sms_sent_limit} SMS Unit</div>
              <div className="other-text">{packagee.email_sent_limit} Email Unit</div>
              <button
                className="package-button"
                onClick={() => handlePackageSubscription(packagee.id)}
              >
                Get Plan
              </button>
            </div>
          ))}
        </div>
      </div>
      {showPaymentPopup && (
        <div className='modal' style={{display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
          <div className='modal-dialog modal-lg modal-dialog-centered' style={{ width: "100%", margin: "0 auto", height: "100%" }}>
            <div className='modal-content' style={{ height: "100%" }}>
              <div className='modal-header'>
                <h5 className='modal-title'>PayStack Payment</h5>
                <button className='btn btn-close' onClick={() => {
                  setShowPaymentPopup(false)
                  setAuthorizationUrl('')
                  setReference('')
                  PackageSubscriptionAPI.verifyPayment(reference).then(
                    (res: any) => {
                      if (res?.data?.success) {
                        toast.success(res?.data?.message, { theme: 'dark' })
                        navigate('/settings/payment-history')
                      } else {
                        toast.error(res?.data?.message, {theme: 'dark'})
                      }
                    },
                    (err: any) => {
                      toast.error(err?.response?.data?.message, {theme: 'dark'})
                    }
                  )
                }}></button>
              </div>
              <div className='modal-body users'>
              <iframe src={authorizationUrl} style={{ width: "100%", height: "100%", border: "none" }} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default PackageSubscription
